module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_1_5.210abadf.png";